"use strict";
var gpsPointSchema = require('./gpsPointSchema');
var segmentSchema = {
    type: 'object',
    required: ['time'],
    additionalProperties: false,
    dependencies: {
        target: {
            required: ['targetId']
        },
        targetId: {
            required: ['target']
        }
    },
    properties: {
        segmentId: {
            type: 'string'
        },
        time: {
            type: 'string',
            format: 'date-time'
        },
        target: {
            type: 'string',
            pattern: 'activity|media'
        },
        targetId: {
            type: 'string'
        },
        points: {
            type: 'array',
            items: gpsPointSchema('height', 'time')
        },
        speed: {
            type: 'number'
        },
        targetDistance: {
            type: 'number'
        }
    }
};
module.exports = segmentSchema;
